import { render, staticRenderFns } from "./MatrixMoodEmoji.vue?vue&type=template&id=2d07b3c1"
import script from "./MatrixMoodEmoji.vue?vue&type=script&lang=js"
export * from "./MatrixMoodEmoji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports